const getCSKeys = async () => {
  if (!window.keyProvider) {
    console.error("Not running in the proper environment.");
    return { clientId: "", clientSecret: "" };
  }

  try {
    const clientId = await window.keyProvider.getKey("ACID");
    const clientSecret = await window.keyProvider.getKey("ACST");
    return { clientId, clientSecret };
  } catch (error) {
    console.error("Error fetching ACs", error);
    return { clientId: "", clientSecret: "" };
  }
};

export default {
  getCSKeys,
};
